import enUS from './en-us.json';

export default {
  'en-us': enUS,
};
